class SPARQLQuery {

    constructor(selectedLanguage, lon_min, lon_max, lat_min, lat_max, selectedPlaceTypes = [], includeLabeled = false) {
        this.selectedLanguage = selectedLanguage;
        this.selectedPlaceTypes = selectedPlaceTypes;
        this.includeLabeled = includeLabeled;
    }

    // Generate subclass matching clauses for selected place types
    generatePlaceTypeSubclassMatching() {
        if (!this.selectedPlaceTypes || this.selectedPlaceTypes.length === 0) {
            // Fallback to default city types if none selected
            return `{
                ?place wdt:P31/wdt:P279* wd:Q515 .  # city and subclasses
                BIND(wd:Q515 AS ?matchedType)
            } UNION {
                ?place wdt:P31/wdt:P279* wd:Q3957 .  # town and subclasses
                BIND(wd:Q3957 AS ?matchedType)
            } UNION {
                ?place wdt:P31/wdt:P279* wd:Q532 .   # village and subclasses
                BIND(wd:Q532 AS ?matchedType)
            } UNION {
                ?place wdt:P31/wdt:P279* wd:Q15284 . # municipality and subclasses
                BIND(wd:Q15284 AS ?matchedType)
            }`;
        }

        const unionClauses = this.selectedPlaceTypes.map(id =>
            `{ 
                ?place wdt:P31/wdt:P279* wd:${id} . 
                BIND(wd:${id} AS ?matchedType)
            }`
        ).join(' UNION ');

        return unionClauses;
    }

    // Alternative query using spatial search service (for circular regions)
    getSpatialPlacesQuery(centerLat, centerLon, radiusKm = 25) {
        const languageFilter = this.includeLabeled ? 
            `# Include all places (with and without existing labels)
            OPTIONAL { 
                ?place rdfs:label ?existingLabel . 
                FILTER(LANG(?existingLabel) = "${this.selectedLanguage}") 
            }` :
            `# Exclude places that already have labels in the selected language
            FILTER NOT EXISTS { 
                ?place rdfs:label ?languageLabel . 
                FILTER(LANG(?languageLabel) = "${this.selectedLanguage}") 
            }`;

        return `
        SELECT DISTINCT ?place ?placeLabel ?coordinates ?matchedType ?matchedTypeLabel ?existingLabel
        WHERE {
            # 1. SPATIAL SEARCH SERVICE (most efficient)
            SERVICE wikibase:around {
                ?place wdt:P625 ?coordinates .
                bd:serviceParam wikibase:center "Point(${centerLon} ${centerLat})"^^geo:wktLiteral .
                bd:serviceParam wikibase:radius "${radiusKm}" .
            }
            
            # 2. SUBCLASS TYPE MATCHING (user-selected place types and their subclasses)
            # This will bind ?matchedType to the specific type that matched the search
            {
                ${this.generatePlaceTypeSubclassMatching()}
            }
            
            # 3. LANGUAGE FILTER (conditional based on includeLabeled setting)
            ${languageFilter}
            
            SERVICE wikibase:label { 
                bd:serviceParam wikibase:language "en" 
            }
        }
        ORDER BY ?placeLabel
        LIMIT 500
        `;
    }
}

export default SPARQLQuery;